//import sentry from "./services/sentry";

import Vue from "vue";
import App from "./App.vue";

import store from "./store";
import { i18n } from "./lang";

import eventBus from "./services/eventBus";
import controller from "./controller";
import specs from './specs'
import utils from './utils'

import vSelect from 'vue-select'

// Matomo Assets
import "./lib/matomo.raw-lib.js";

(async () => {

  if (process.env.NODE_ENV == 'test' || utils.is_localhost()) {
    document.getElementsByTagName('body')[0].style.height = '250vh'
  }

  if (specs.beforeInit) {
    specs.beforeInit()
  }

  await store.dispatch("FETCH_STORE_ID", specs._GUID);
  await store.dispatch("FETCH_CONFIG");

  Vue.component('v-select', vSelect)
  Vue.config.productionTip = false;
  Vue.prototype.$eb = eventBus;

  new Vue({
    store,
    i18n: i18n.get(),
    render: (h) => h(App),
  }).$mount("#app-box-cleed");
})()
